import React from 'react';
import PropTypes from 'prop-types';
import Asset from '../AssetRowComponent';

const AssetNode = ({
    asset,
    index,
    selectedAsset,
    onSelectAsset,
    allAssets,
    leftPanelSize,
    depth,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const indentPx = depth * 24;
    const hasSelectionDot = !!selectionNodeIds?.has(`asset-${asset?.assetId}`);
    const selectionCount = selectedAssetSignalCounts?.[asset?.assetId] ?? 0;
    return (
        <div
            className={'hierarchy-asset-row'}
        >
            <Asset
                index={index}
                selectedAsset={selectedAsset}
                asset={asset}
                allAssets={allAssets}
                onSelectedItem={onSelectAsset}
                showThreshold={asset?.showThreshold}
                showTrend={asset?.showTrend}
                isHorizontalScrollActive={false}
                isLabelVisible={true}
                leftPanelSize={leftPanelSize}
                indentPadding={indentPx}
                hasSelectionDot={hasSelectionDot}
                selectionCount={selectionCount}
            />
        </div>
    );
};

AssetNode.propTypes = {
    asset: PropTypes.object.isRequired,
    index: PropTypes.number,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    allAssets: PropTypes.array,
    leftPanelSize: PropTypes.number,
    depth: PropTypes.number,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default AssetNode;
